import { render, staticRenderFns } from "./HomeSide.vue?vue&type=template&id=3fdf6440&scoped=true"
import script from "./HomeSide.vue?vue&type=script&lang=ts"
export * from "./HomeSide.vue?vue&type=script&lang=ts"
import style0 from "./HomeSide.vue?vue&type=style&index=0&id=3fdf6440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdf6440",
  null
  
)

export default component.exports